import { type ChatMessage, type ChatMessageWithMetadata } from "@fitness-app/data-models/entities/Chat";

type StoredMessage = ChatMessage | ChatMessageWithMetadata;

const sentAt = (message: StoredMessage): number => new Date(message.createdAt).getTime();

/**
 * The newest page from the database folded into what the store already holds, for a refresh
 * (tab return, socket reconnect). Replacing the list wholesale threw away the older pages the
 * reader had scrolled to and any message the live socket delivered after the query took its
 * snapshot. A row from the database wins over its stored copy (edits, reactions); everything
 * else stays. Newest first, like the list itself.
 */
export const mergeLatestMessages = (existing: StoredMessage[], latest: StoredMessage[]): StoredMessage[] => {
  const byId = new Map<string, StoredMessage>();
  for (const message of existing) {
    byId.set(message.id, message);
  }
  for (const message of latest) {
    byId.set(message.id, message);
  }
  return [...byId.values()].sort((a, b) => sentAt(b) - sentAt(a));
};
